import { NgModule } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { ToolbarModule } from 'primeng/toolbar';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { DatePickerModule } from 'primeng/datepicker';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { TabsModule } from 'primeng/tabs';
import { FileUploadModule } from 'primeng/fileupload';
import { TextareaModule } from 'primeng/textarea';
import { ScrollTopModule } from 'primeng/scrolltop';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MultiSelectModule } from 'primeng/multiselect';
import { SkeletonModule } from 'primeng/skeleton';
import { BlockUIModule } from 'primeng/blockui';
import { ContextMenuModule } from 'primeng/contextmenu';
import { TagModule } from 'primeng/tag';
// v18: p-inputgroup / p-float-label / p-input-icon-left dejaron de ser clases CSS
// sueltas (las pintaba primeng/resources/primeng.css) y ahora son componentes.
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { FloatLabelModule } from 'primeng/floatlabel';

@NgModule({
    declarations: [],
    imports: [
        InputTextModule,
        CardModule,
        ButtonModule,
        DrawerModule,
        ToolbarModule,
        MenuModule,
        PanelMenuModule,
        DialogModule,
        MessagesModule,
        ToastModule,
        DatePickerModule,
        PanelModule,
        TableModule,
        SelectModule,
        InputNumberModule,
        InputMaskModule,
        TabsModule,
        FileUploadModule,
        TextareaModule,
        ScrollTopModule,
        ProgressSpinnerModule,
        MultiSelectModule,
        SkeletonModule,
        BlockUIModule,
        ContextMenuModule,
        TagModule,
        InputGroupModule,
        InputGroupAddonModule,
        IconFieldModule,
        InputIconModule,
        FloatLabelModule,
    ],
    exports: [
        InputTextModule,
        CardModule,
        ButtonModule,
        DrawerModule,
        ToolbarModule,
        MenuModule,
        PanelMenuModule,
        DialogModule,
        MessagesModule,
        ToastModule,
        DatePickerModule,
        PanelModule,
        TableModule,
        SelectModule,
        InputNumberModule,
        InputMaskModule,
        TabsModule,
        FileUploadModule,
        TextareaModule,
        ScrollTopModule,
        ProgressSpinnerModule,
        MultiSelectModule,
        SkeletonModule,
        BlockUIModule,
        ContextMenuModule,
        TagModule,
        InputGroupModule,
        InputGroupAddonModule,
        IconFieldModule,
        InputIconModule,
        FloatLabelModule,
    ]
})
export class PrimeNgModule { }
